import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { LiveAgentStrip } from '../components/LiveAgentStrip';
import { ValueProp } from '../components/ValueProp';
import { VerticalSolutions } from '../components/VerticalSolutions';
import { AgentDemo } from '../components/AgentDemo';
import { HowItWorks } from '../components/HowItWorks';
import { DeploymentSection } from '../components/DeploymentSection';
import { BeforeAfter } from '../components/BeforeAfter';
import { TrustSection } from '../components/TrustSection';
import { SocialProof } from '../components/SocialProof';
import { AboutSection } from '../components/AboutSection';
import { CTASection } from '../components/CTASection';
import { SectionDivider } from '../components/SectionDivider';
import { QuietConfidence } from '../components/QuietConfidence';
export function HomePage() {
  return <main className="relative z-10" data-id="element-771">
      <HeroSection data-id="element-772" />
      <LiveAgentStrip data-id="element-773" />
      <SectionDivider data-id="element-774" />
      <ValueProp data-id="element-775" />
      <QuietConfidence text="Not built for demos. Built for operations." data-id="element-776" />
      <VerticalSolutions data-id="element-777" />
      <SectionDivider data-id="element-778" />
      <AgentDemo data-id="element-779" />
      <QuietConfidence text="Where reasoning meets execution." data-id="element-780" />
      <HowItWorks data-id="element-781" />
      <SectionDivider data-id="element-782" />
      <DeploymentSection data-id="element-783" />
      <QuietConfidence text="Context is everything." data-id="element-784" />
      <BeforeAfter data-id="element-785" />
      <SectionDivider data-id="element-786" />
      <TrustSection data-id="element-787" />
      <SectionDivider data-id="element-788" />
      <SocialProof data-id="element-789" />
      <SectionDivider data-id="element-790" />
      <AboutSection data-id="element-791" />
      <SectionDivider data-id="element-792" />
      <CTASection data-id="element-793" />
    </main>;
}